import { render } from "./AppImportWarning.vue?vue&type=template&id=df375860"
import script from "./AppImportWarning.vue?vue&type=script&lang=js"
export * from "./AppImportWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__